import type { ProjectTypeSymbolValue } from './projectTypeColors';

/**
 * Знак типа проекта в потоке текста: символ — как есть, иконка — 1.2em, чтобы в квадрате значка
 * занимать столько же, сколько буквы (концепт new-project-types: 12 px в 16 px, 15 px в 20 px).
 * В строке текста (расписание) svg по умолчанию стоит низом на базовой линии и торчит над буквами:
 * сдвиг −0.25em ставит середину рисунка на середину заглавных. В flex/grid-квадрате значка сдвиг не действует.
 * Размер — в style, не только атрибутами: слот иконки пункта меню растягивает svg до 16 px, и хлопушка закрывала бы весь квадрат.
 */
export function ProjectTypeSymbol({ symbol }: { symbol: ProjectTypeSymbolValue }) {
  if (typeof symbol === 'string') return <>{symbol}</>;
  const Icon = symbol;
  return <Icon aria-hidden size="1.2em" strokeWidth={2.25} style={{ width: '1.2em', height: '1.2em', verticalAlign: '-0.25em' }} />;
}
